import {
  APPROVES_TEAMS,
  EVALUATION_HOURS,
  EVALUATION_HOURS_ERROR,
  EVALUATION_HOURS_SUCCESS,
  REJECTS_TEAMS,
  REPORT_QUICK_SEND_TO_CLIENT,
  REPORT_QUICK_SEND_TO_CLIENT_ERROR,
  REPORT_QUICK_SEND_TO_CLIENT_SUCCESS,
  TEAMS_APPROVES_ERROR,
  TEAMS_APPROVES_SUCCESS,
  TEAMS_REJECTS_ERROR,
  TEAMS_REJECTS_SUCCESS,
  TEAMS_USER_ERROR,
  TEAMS_USER_SUCCESS,
  USER_TEAMS,
  WORK_REPORTS_SUCCESS,
  SET_MODAL,
  SET_ROW_LIST_DATA,
  SET_MOBILE_VIEW,
  SET_SELECTED_ARRAY_LISTS,
  SET_SELECTE_TOGGLE,
  SET_TEAM_SCREEN_MODAL,
  SET_SELECTED_REPORT_ITEM,
  SET_ACTIVE_SCREEN_FILTER,
  SET_VERIFY_SCREEN,
  SET_SUMMARY_DATA_TEAM,
  SET_SUMMARY_MODAL_TEAM,
  SET_SUMMARY_MODAL,
  SET_SUMMARY_DATA,
  SET_FULL_VIEW_MODAL_TEAM,
  SET_FULL_VIEW_REPORT,
  SET_SELECTED_HOURS_TEAM,
  GET_HOURS_REPORT,
  GET_HOURS_REPORT_SUCCESS,
  SET_BOOK_MARKS
} from "./actionType"

const initialState = {
  teamReportSuccessList: null,
  teamsReportError: null,
  teamSheetApproveError: null,
  teamApproveSuccessList: null,
  teamRejectSuccessList: null,
  evaluationHours: null,
  evaluationHoursSuccess: null,
  evaluationHoursError: null,
  sendreporttoclientSuccess: null,
  sendreporttoclientError: null,
  sendreporttoclient: null,
  ismodal: false,
  rowlistdata: [],
  isMobile: window.innerWidth < 900,
  selectedArrayLists: [],
  selectedReportItem: {},
  selectToggle: false,
  teamscreenModal: false,
  activeScreenFilter: "UNVERIFIED",
  verifyScreen: false,
  summarydatasteam: {},
  summarydatas: {},
  summaryModalteam: false,
  summaryModal: false,
  fullviewreport: null,
  FullviewModalteam: false,
  selectedHoursteam: [],
  bookmarkedLists: []
}
const userteamsReport = (state = initialState, action) => {
  switch (action.type) {
    case USER_TEAMS:
      state = {
        ...state,
        teamSheetReportSuccessList: null,
        teamSheetReportError: null,
      }
      break

    case TEAMS_USER_SUCCESS:
      state = {
        ...state,
        teamReportSuccessList: action.payload,
        teamsReportError: null,
      }
      break

    case TEAMS_USER_ERROR:
      state = { ...state, teamsReportError: action.payload }
      break

    case APPROVES_TEAMS:
      state = {
        ...state,

        teamSheetReportError: null,
      }
      break

    case TEAMS_APPROVES_SUCCESS:
      state = {
        ...state,
        teamApproveSuccessList: action.payload,
        teamSheetApproveError: null,
      }
      break

    case TEAMS_APPROVES_ERROR:
      state = { ...state, teamSheetApproveError: action.payload }
      break

    case REJECTS_TEAMS:
      state = {
        ...state,
        teamSheetReportError: null,
      }
      break

    case TEAMS_REJECTS_SUCCESS:
      state = {
        ...state,
        teamRejectSuccessList: action.payload,
        teamsReportError: null,
      }
      break

    case TEAMS_REJECTS_ERROR:
      state = { ...state, teamsReportError: action.payload }
      break
    case WORK_REPORTS_SUCCESS:
      state = { ...state, teamsWorkreport: action.payload.data }
      break
    case EVALUATION_HOURS:
      state = {
        ...state,
        evaluationHoursError: null,
      }
      break
    case EVALUATION_HOURS_SUCCESS:
      state = {
        ...state,
        evaluationHoursSuccess: action?.payload?.data,
        evaluationHoursError: null,
      }
      break
    case EVALUATION_HOURS_ERROR:
      state = {
        ...state,
        evaluationHoursError: action?.payload,
      }
      break
    
    // send report to client
    case REPORT_QUICK_SEND_TO_CLIENT:
      state = {
        ...state,
        sendreporttoclientError: null,
      }
      break
    case REPORT_QUICK_SEND_TO_CLIENT_SUCCESS:
      state = {
        ...state,
        sendreporttoclientSuccess: action?.payload,
        sendreporttoclientError: null,
      }
      break
    case REPORT_QUICK_SEND_TO_CLIENT_ERROR:
      state = {
        ...state,
        sendreporttoclientError: action?.payload,
      }
      break
  
    case SET_MODAL:
      state = {
        ...state,
        ismodal: action?.payload,
      }
      break
    case SET_ROW_LIST_DATA:
      state = {
        ...state,
        rowlistdata: action?.payload,
      }
      break
    case SET_MOBILE_VIEW:
      state = {
        ...state,
        isMobile: action?.payload,
      }
      break
    case SET_SELECTED_ARRAY_LISTS:
      state = {
        ...state,
        selectedArrayLists: action?.payload,
      }
      break
    case SET_SELECTED_REPORT_ITEM:
      state = {
        ...state,
        selectedReportItem: action?.payload,
      }
      break
    case SET_SELECTE_TOGGLE:
      state = {
        ...state,
        selectToggle: action?.payload,
      }
      break
    case SET_TEAM_SCREEN_MODAL:
      state = {
        ...state,
        teamscreenModal: action?.payload,
      }
      break
    case SET_ACTIVE_SCREEN_FILTER:
      state = {
        ...state,
        activeScreenFilter: action?.payload,
      }
      break
    case SET_VERIFY_SCREEN:
      state = {
        ...state,
        verifyScreen: action?.payload,
      }
      break

    case SET_SUMMARY_DATA_TEAM:
      state = {
        ...state,
        summarydatasteam: action?.payload,
      }
      break
    case SET_SUMMARY_MODAL_TEAM:
      state = {
        ...state,
        summaryModalteam: action?.payload,
      }
      break
    case SET_SUMMARY_MODAL:
      state = {
        ...state,
        summaryModal: action?.payload,
      }
      break
    case SET_SUMMARY_DATA:
      state = {
        ...state,
        summarydatas: action?.payload,
      }
      break
    case SET_FULL_VIEW_MODAL_TEAM:
      state = {
        ...state,
        FullviewModalteam: action?.payload,
      }
      break
    case SET_FULL_VIEW_REPORT:
      state = {
        ...state,
        fullviewreport: action?.payload,
      }
      break
    case SET_SELECTED_HOURS_TEAM:
      state = {
        ...state,
        selectedHoursteam: action?.payload,
      }
      break
    // get api for hours report employee
    case GET_HOURS_REPORT:
      state = {
        ...state,
        gethoursreport: action?.payload,
      }
      break
      case GET_HOURS_REPORT_SUCCESS:
        state = {
          ...state,
          hourReportSuccessList: action.payload,
          hourReportError: null,
        }
        break
      case SET_BOOK_MARKS:
        state = {
          ...state,
          bookmarkedLists: action?.payload
        }
    default:
      state = { ...state }
      break
  }
  return state
}

export default userteamsReport
